<template>
  <v-layout
    v-if="activeAction"
    class="home-footer-info"
    id="current-action"
    style="flex: none;"
  >
    <span style="padding-left: 1px; text-transform: uppercase;">
      {{ $t(activeAction) }}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: "HomeFooterActiveAction",

  computed: {
    activeAction() {
      let action = this.$store.getters.tools_selectedAction;
      if (action) {
        return action.charAt(0).toUpperCase() + action.slice(1);
      }
      return "";
    }
  }
};
</script>

<style scoped>
#current-action {
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/ActiveAction.vue